import { render, staticRenderFns } from "./TeacherSurvey.vue?vue&type=template&id=f7acf598&scoped=true"
import script from "./TeacherSurvey.vue?vue&type=script&lang=js"
export * from "./TeacherSurvey.vue?vue&type=script&lang=js"
import style0 from "./TeacherSurvey.vue?vue&type=style&index=0&id=f7acf598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7acf598",
  null
  
)

export default component.exports